module.exports = __webpack_public_path__ + "static/media/ci-con-chip.0e006581.mp4";